import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BathrobeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BathrobeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.1573 6.70426L15.4912 2.26021C15.4119 2.2126 15.3166 2.18085 15.2214 2.18085H9.50761C9.41238 2.18085 9.31715 2.21259 9.23779 2.26021L2.57172 6.70426C2.46062 6.78362 2.39713 6.89472 2.36539 7.02169C2.34952 7.14866 2.36539 7.27564 2.44475 7.38674L4.82549 10.7198C4.90485 10.8309 5.01595 10.8944 5.14292 10.9102C5.26989 10.9261 5.39687 10.8944 5.4921 10.8309L7.12687 9.62464V21.7029C7.12687 21.9727 7.3332 22.1791 7.60302 22.1791H8.98385C9.25367 22.1791 9.46 21.9727 9.46 21.7029C9.46 21.4331 9.25367 21.2268 8.98385 21.2268H8.07917V14.402H10.0949V21.7029C10.0949 21.9727 10.3012 22.1791 10.571 22.1791H17.126C17.3958 22.1791 17.6021 21.9727 17.6021 21.7029V9.62464L19.221 10.815C19.3163 10.8944 19.4591 10.9261 19.5702 10.8944C19.6972 10.8785 19.8083 10.7991 19.8876 10.7039L22.2684 7.37087C22.3477 7.25977 22.3795 7.1328 22.3477 7.00582C22.3319 6.89472 22.2525 6.78362 22.1573 6.70426ZM14.4596 3.13315L12.2534 7.64069L10.2377 3.13315H14.4596ZM16.6498 21.2268H11.0472V14.402H16.6498V21.2268ZM19.3956 9.76748L17.4117 8.30729C17.2688 8.19619 17.0784 8.18032 16.9197 8.25968C16.7609 8.33904 16.6657 8.49775 16.6657 8.68821V13.4497H8.07917V8.68821C8.07917 8.51362 7.98394 8.33903 7.82522 8.25968C7.6665 8.18033 7.47604 8.19619 7.3332 8.30729L5.34925 9.76748L3.53989 7.22802L9.30128 3.37122L11.682 8.70408C11.6979 8.71995 11.6979 8.75169 11.7138 8.76757L10.6186 10.9896C10.4282 11.3705 10.2853 11.7832 10.206 12.1958C10.1584 12.4498 10.3171 12.7037 10.571 12.7672C10.6028 12.7672 10.6345 12.7831 10.6662 12.7831C10.8884 12.7831 11.0789 12.6244 11.1265 12.4022C11.2059 12.0689 11.317 11.7355 11.4598 11.4181L15.4119 3.35535L21.2209 7.22802L19.3956 9.76748Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BathrobeIcon;
